if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      const variantId = this.form.querySelector('[name=id]').value;

      /* ================================
          OVERSIZED CART RESTRICTION
          ================================ */

        try {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();

          // Get product tags of the item being added
          const productTagsInput = this.form.querySelector('[name="product-tags"]');
          const productTags = productTagsInput
            ? productTagsInput.value.split(',').map(tag => tag.trim())
            : [];

          // Determine if this product is oversized and its type
          const isOversizedPreorder = productTags.includes('oversized-preorder');
          const isOversizedDefault = productTags.includes('oversized-default');
          const isOversizedProduct = isOversizedPreorder || isOversizedDefault;


          const cartHasItems = cart.items.length > 0;

          // Check if cart already contains any oversized items
          const cartHasOversized = cart.items.some(item => {
  return item.properties && item.properties._oversized;
});


          console.log('start');

          /* 🚫 RULE 1: Cannot add oversized if cart is NOT empty */
          if (isOversizedProduct && cartHasItems) {
            const msg = isOversizedPreorder
              ? 'OVERSIZED PREORDER - NO OTHER ITEMS ALLOWED IN CART'
              : 'OVERSIZED ITEM - NO OTHER ITEMS ALLOWED IN CART';
            this.handleErrorMessage(msg);
          console.log('rule 1');
            return;
          }

          /* 🚫 RULE 2: Cannot add anything if cart already has oversized */
          if (!isOversizedProduct && cartHasOversized) {
            // Check which oversized is in cart to show correct message
            const oversizedType = cart.items.find(item =>
              item.properties && item.properties._oversized
            )?.properties._oversized;
            const msg = oversizedType.includes('preorder')
              ? 'AN OVERSIZED ITEM IS ALREADY IN YOUR CART AND MUST BE PURCHASED ALONE'
              : 'AN OVERSIZED ITEM IS ALREADY IN YOUR CART AND MUST BE PURCHASED ALONE';
            this.handleErrorMessage(msg);
          console.log('rule 2');
            return;
          }

        } catch (error) {
          console.error('Oversized cart check failed', error);
          return;
        }



      /* ================================
         CONTINUE NORMAL ADD TO CART
         ================================ */

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
